import Badge from './Badge.vue';

export default Badge;



// WEBPACK FOOTER //
// ./src/components/parts/vacancies/card/components/badge/index.ts